// Lottie rollover — plays forward on hover, reverse on mouseleave.
// Hooks into [data-lottie-rollover] with data-lottie-src pointing at a JSON file.

import lottie from 'imports/lottie-web'

const lottieRollover = {
    init() {
        document.querySelectorAll('[data-lottie-rollover]').forEach((el) => {
            if (el._lottie) return

            const container = el.querySelector('.lottie-rollover__anim') || el
            const src = el.dataset.lottieSrc
            if (!src) return

            const instance = lottie.loadAnimation({
                container,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: src,
            })
            el._lottie = instance

            // Start at frame 0 so hover plays 0 → end, leave plays end → 0.
            instance.goToAndStop(0, true)

            el.addEventListener('mouseenter', () => {
                instance.setDirection(1)
                instance.play()
            })
            el.addEventListener('mouseleave', () => {
                instance.setDirection(-1)
                instance.play()
            })
        })
    }
}

export default lottieRollover
